let folder = 'insights'
export const state = () => ({
  overview: null,
  intro: null,
  quote: null,
  numbers: null,
  downloadFileExists: false
})
export const getters = {
  overview(state) {
    return state.overview
  },
  intro(state) {
    return state.intro
  },
  quote(state) {
    return state.quote
  },
  numbers(state) {
    return state.numbers
  },
  downloadFileExists(state) {
    return state.downloadFileExists
  }
}
export const mutations = {
  setOverview(state, { data }) {
    state.overview = data
  },
  setIntro(state, { data }) {
    state.intro = data
  },
  setQuote(state, { data }) {
    state.quote = data
  },
  setNumbers(state, { data }) {
    state.numbers = data
  },
  setDownloadFileExists(state, { data }) {
    state.downloadFileExists = data
  }
}
export const actions = {
  checkDownloadFile({ commit }, { path }) {
    commit('setDownloadFileExists', { data: false })
    return this.$axios
      .post('/api/file/exists', { path: path })
      .then((res) => {
        if (res.data && res.data.exists) {
          commit('setDownloadFileExists', { data: res.data.exists })
        } else {
          commit('setDownloadFileExists', { data: false })
        }
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getOverview({ commit, rootState }, { articleFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${articleFolder}/overview.json`
      )
      .then((res) => {
        commit('setOverview', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getIntro({ commit, rootState }, { articleFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${articleFolder}/intro.json`
      )
      .then((res) => {
        commit('setIntro', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getQuote({ commit, rootState }, { articleFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${articleFolder}/quote.json`
      )
      .then((res) => {
        commit('setQuote', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getNumbers({ commit, rootState }, { articleFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${articleFolder}/numbers.json`
      )
      .then((res) => {
        commit('setNumbers', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
